export const NOTIFICATIONS = {
  ADD: "NOTIFICATIONS_ADD",
  DELETE: "NOTIFICATIONS_DELETE",
  RESET: "NOTIFICATIONS_RESET",
  PUSHER_UPDATE: "NOTIFICATIONS_PUSHER_UPDATE"
};

export const SYSTEM_NOTIFICATIONS = {
  REQUEST: "SYSTEM_NOTIFICATIONS_REQUEST",
  RECEIVE: "SYSTEM_NOTIFICATIONS_RECEIVE",
  FAILURE: "SYSTEM_NOTIFICATIONS_FAILURE"
};
